import type { RccCandidate, TFn } from './rccTypes';

export type CandidateTitleSource = 'current_role' | 'role_preferences' | 'preview' | 'fallback';

function truncate(text: string, max: number): string {
  if (text.length <= max) return text;
  return `${text.slice(0, max - 1).trimEnd()}…`;
}

/** Presentation-only headline when `current_role` is missing. No API or handler changes. */
export function getCandidateDisplayTitle(
  c: RccCandidate,
  t: TFn,
): { title: string; source: CandidateTitleSource } {
  const role = c.current_role?.trim();
  if (role) return { title: role, source: 'current_role' };

  const prefs = c.role_preferences?.trim();
  if (prefs) {
    const first = prefs.split(/[,;|/]/)[0]?.trim() || prefs;
    return { title: truncate(first, 60), source: 'role_preferences' };
  }

  const preview = c.preview?.trim();
  if (preview) {
    const line = preview.split('\n').map((s) => s.trim()).find(Boolean) || preview;
    return { title: truncate(line, 60), source: 'preview' };
  }

  return { title: t('card.unnamed_candidate'), source: 'fallback' };
}
